if (!customElements.get('elix-research-kit')) {
  customElements.define('elix-research-kit', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector('[data-research-kit]');
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-kit-open]');
      this.input.checked = false;
      this.input.disabled = this.dataset.kitAvailable !== 'true' || !window.ElixCartAdd;
      // Express checkout bypasses cart add; keep it out of the selected-kit path.
      this.input.addEventListener('change', () => {
        const express = this.closest('form')?.querySelector('.shopify-payment-button');
        if (express) express.hidden = this.input.checked;
      });
      this.openButton.addEventListener('click', () => {
        this.dialog.showModal();
        this.dialog.querySelector('[data-kit-close]').focus();
      });
      this.querySelector('[data-kit-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => this.openButton.focus());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
    }
  });
}
